export { TabBarItem } from './TabBarItem';
export type { TabBarItemProps, TabBarIcon, NavigationItem } from './TabBarItem';
export type { NavigationState } from '../Navigation/NavigationPressable';
